import CompanyDetailsContainer from '../containers/CompanyDetailsPage.container';

const CompanyDetailsLayout = () => <CompanyDetailsContainer />;

export default CompanyDetailsLayout;
